<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      spinner="bar-fade-scale"
      color="#1976d2"
      size="50"
      is-full-screen
    />
    <v-layout v-if="ServerError" wrap justify-center>
      <v-flex px-5 pt-5 xs12 sm12 md12 lg12 xl12 text-center>
        <ServerError />
      </v-flex>
    </v-layout>
    <v-layout justify-start wrap>
      <v-flex xs12>
        <v-card>
          <v-layout justify-start wrap pt-6>
            <v-flex xs12 sm6 md6>
              <v-layout justify-start wrap>
                <v-flex xs2 sm2 md1 lg1 pt-1 text-center pl-5>
                  <v-img
                    width="30px"
                    src="./../../assets/images/analytics.svg"
                  ></v-img>
                </v-flex>
                <v-flex xs10 sm10 md3 lg3 pl-md-4>
                  <span
                    style="
                      font-family: nunitosansbold;
                      font-size: 20px;
                      color: #000000;
                    "
                    >Analytics</span
                  >
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-card-text>
            <v-layout justify-center wrap>
              <v-flex xs12 sm12 md12 pa-2>
                <v-select
                  dense
                  style="font-family: nunitosansregular"
                  outlined
                  label="Select"
                  v-model="cls"
                  :items="items"
                  item-text="name"
                  item-value="value"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm6 md3 pa-2 v-if="cls == 'Class'">
                <v-select
                  dense
                  style="font-family: nunitosansregular"
                  outlined
                  v-model="standard"
                  label="Standard"
                  :items="standardArray"
                  item-text="standardName"
                  item-value="_id"
                  @change="getData()"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm6 md3 pa-2 v-if="cls == 'Class'">
                <v-select
                  v-model="division"
                  dense
                  style="font-family: nunitosansregular"
                  outlined
                  label="Division"
                  :items="divisionArray"
                  item-text="divisionName"
                  item-value="_id"
                  @change="getData()"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm6 md3 pa-2 v-if="cls == 'Class'">
                <v-select
                  dense
                  v-model="subject"
                  style="font-family: nunitosansregular"
                  outlined
                  label="Subject"
                  :items="subArray"
                  item-text="subjectName"
                  item-value="_id"
                  @change="getData()"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm6 md3 pa-2 v-if="cls == 'Class'">
                <v-btn
                  dark
                  @click="getData()"
                  block
                  style="font-family: nunitosansregular"
                  color="#9B8DFD"
                  >SEARCH</v-btn
                >
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout justify-center wrap py-5>
      <v-flex xs12>
        <v-card>
          <v-card-text>
            <v-card outlined>
              <v-card-text v-if="cls == 'Class'">
                <v-layout justify-center wrap v-if="data">
                  <v-flex xs12 pt-6>
                    <span
                      style="
                        color: #000000;
                        font-family: nunitosansbold;
                        font-size: 18px;
                      "
                      >{{ data.dataReference }} Grade Performance</span
                    >
                  </v-flex>
                  <v-flex xs12>
                    <span
                      style="
                        color: #606060;
                        font-family: nunitosansregular;
                        font-size: 12px;
                      "
                      >Cumulative | Male | Female</span
                    >
                  </v-flex>
                  <v-flex xs12>
                    <div id="chart" v-if="flag">
                      <apexchart
                        type="line"
                        height="350"
                        :options="chartOptions"
                        :series="series"
                      ></apexchart>
                    </div>
                  </v-flex>
                  <v-flex xs12>
                    <v-layout justify-start wrap>
                      <v-flex xs12 sm6 md2 pa-2 text-center>
                        <v-card outlined>
                          <v-card-text>
                            <span
                              style="
                                color: #4e4e4e;
                                font-family: nunitosansregular;
                                font-size: 12px;
                              "
                              >Min:
                            </span>
                            <span
                              style="
                                color: #000000;
                                font-family: nunitosanssemibold;
                                font-size: 12px;
                              "
                              >{{ cumilative1.minCGPA }}</span
                            >
                          </v-card-text>
                        </v-card>
                      </v-flex>
                      <v-flex xs12 sm6 md2 pa-2 text-center>
                        <v-card outlined>
                          <v-card-text>
                            <span
                              style="
                                color: #4e4e4e;
                                font-family: nunitosansregular;
                                font-size: 12px;
                              "
                              >Avg:
                            </span>
                            <span
                              style="
                                color: #000000;
                                font-family: nunitosanssemibold;
                                font-size: 12px;
                              "
                              >{{ cumilative1.avgCGPA }}</span
                            >
                          </v-card-text>
                        </v-card>
                      </v-flex>
                      <v-flex xs12 sm6 md2 pa-2 text-center>
                        <v-card outlined>
                          <v-card-text>
                            <span
                              style="
                                color: #4e4e4e;
                                font-family: nunitosansregular;
                                font-size: 12px;
                              "
                              >Max:
                            </span>
                            <span
                              style="
                                color: #000000;
                                font-family: nunitosanssemibold;
                                font-size: 12px;
                              "
                              >{{ cumilative1.maxCGPA }}</span
                            >
                          </v-card-text>
                        </v-card>
                      </v-flex>
                      <v-layout justify-end wrap>
                        <v-flex xs12 sm4 md3 pa-2 align-self-end>
                          <span
                            style="
                              color: #70ce11;
                              font-family: nunitosansregular;
                              font-size: 12px;
                            "
                            >Cumulative</span
                          >
                          <v-layout justify-start wrap>
                            <v-flex xs6>
                              <v-progress-linear
                                value="100"
                                color="#70CE11"
                              ></v-progress-linear>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm4 md2 pa-2 align-self-end>
                          <span
                            style="
                              color: #8474f7;
                              font-family: nunitosansregular;
                              font-size: 12px;
                            "
                            >Male</span
                          >
                          <v-layout justify-start wrap>
                            <v-flex xs6>
                              <v-progress-linear
                                value="100"
                                color="#8474F7"
                              ></v-progress-linear>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm4 md2 pa-2 align-self-end>
                          <span
                            style="
                              color: #d82323;
                              font-family: nunitosansregular;
                              font-size: 12px;
                            "
                            >Female</span
                          >
                          <v-layout justify-start wrap>
                            <v-flex xs8>
                              <v-progress-linear
                                value="100"
                                color="#D82323"
                              ></v-progress-linear>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 pa-2>
                    <div class="dottedline"></div>
                  </v-flex>
                </v-layout>
                <table id="customers" class="hidden-sm-and-down" v-if="data">
                  <tr>
                    <td style="color: #8474f7; font-family: nunitosansregular">
                      PERCENTILE
                    </td>
                    <!-- <td style="color: #4d4d4d; font-family: nunitosanslight">
                      0
                    </td> -->
                    <td
                      v-for="(item, i) in percentileTable1"
                      :key="i"
                      style="color: #4d4d4d; font-family: nunitosanslight"
                    >
                      {{ item.percentile }}
                    </td>
                  </tr>
                  <tr>
                    <td style="color: #8474f7; font-family: nunitosansregular">
                      CGPA
                    </td>
                    <td
                      v-for="(item, i) in percentileTable1"
                      :key="i"
                      style="color: #000000; font-family: nunitosanssemibold"
                    >
                      {{ item.CGPA }}
                    </td>
                  </tr>
                </table>
                <v-layout justify-center wrap v-if="!data">
                  <v-flex xs12>
                    <span>No Data...</span>
                  </v-flex>
                </v-layout>
                <v-layout justify-center wrap class="hidden-md-and-up">
                  <v-flex xs6 text-left>
                    <span
                      style="color: #8474f7; font-family: nunitosansregular"
                    >
                      PERCENTILE
                    </span>
                    <v-layout
                      justify-center
                      wrap
                      v-for="(item, i) in percentileTable1"
                      :key="i"
                    >
                      <span
                        style="color: #4d4d4d; font-family: nunitosanslight"
                      >
                        {{ item.percentile }}
                      </span>
                    </v-layout>
                  </v-flex>
                  <v-flex xs6 text-center>
                    <span
                      style="color: #8474f7; font-family: nunitosansregular"
                    >
                      CGPA
                    </span>
                    <v-layout
                      justify-center
                      wrap
                      v-for="(item, i) in percentileTable1"
                      :key="i"
                    >
                      <span
                        style="color: #000000; font-family: nunitosanssemibold"
                      >
                        {{ item.CGPA }}
                      </span>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-card-text v-else>
                <v-layout justify-center wrap>
                  <v-flex xs12>
                    <span
                      style="
                        color: #606060;
                        font-family: nunitosansregular;
                        font-size: 12px;
                      "
                      >Cumulative | Male | Female</span
                    >
                  </v-flex>
                  <v-flex xs12 v-if="cls == 'School'">
                    <div id="chart" v-if="flag">
                      <apexchart
                        type="line"
                        height="350"
                        :options="chartOptions3"
                        :series="series3"
                      ></apexchart>
                    </div>
                  </v-flex>
                  <v-flex xs12>
                    <v-layout justify-start wrap>
                      <v-flex xs12 sm6 md2 pa-2 text-center>
                        <v-card outlined>
                          <v-card-text>
                            <span
                              style="
                                color: #4e4e4e;
                                font-family: nunitosansregular;
                                font-size: 12px;
                              "
                              >Min:
                            </span>
                            <span
                              style="
                                color: #000000;
                                font-family: nunitosanssemibold;
                                font-size: 12px;
                              "
                              >{{ cumilative.minCGPA }}</span
                            >
                          </v-card-text>
                        </v-card>
                      </v-flex>
                      <v-flex xs12 sm6 md2 pa-2 text-center>
                        <v-card outlined>
                          <v-card-text>
                            <span
                              style="
                                color: #4e4e4e;
                                font-family: nunitosansregular;
                                font-size: 12px;
                              "
                              >Avg:
                            </span>
                            <span
                              style="
                                color: #000000;
                                font-family: nunitosanssemibold;
                                font-size: 12px;
                              "
                              >{{ cumilative.avgCGPA }}</span
                            >
                          </v-card-text>
                        </v-card>
                      </v-flex>
                      <v-flex xs12 sm6 md2 pa-2 text-center>
                        <v-card outlined>
                          <v-card-text>
                            <span
                              style="
                                color: #4e4e4e;
                                font-family: nunitosansregular;
                                font-size: 12px;
                              "
                              >Max:
                            </span>
                            <span
                              style="
                                color: #000000;
                                font-family: nunitosanssemibold;
                                font-size: 12px;
                              "
                              >{{ cumilative.maxCGPA }}</span
                            >
                          </v-card-text>
                        </v-card>
                      </v-flex>
                      <v-layout justify-end wrap>
                        <v-flex xs12 sm4 md3 pa-2 align-self-end>
                          <span
                            style="
                              color: #70ce11;
                              font-family: nunitosansregular;
                              font-size: 12px;
                            "
                            >Cumulative</span
                          >
                          <v-layout justify-start wrap>
                            <v-flex xs6>
                              <v-progress-linear
                                value="100"
                                color="#70CE11"
                              ></v-progress-linear>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm4 md2 pa-2 align-self-end>
                          <span
                            style="
                              color: #8474f7;
                              font-family: nunitosansregular;
                              font-size: 12px;
                            "
                            >Male</span
                          >
                          <v-layout justify-start wrap>
                            <v-flex xs6>
                              <v-progress-linear
                                value="100"
                                color="#8474F7"
                              ></v-progress-linear>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm4 md2 pa-2 align-self-end>
                          <span
                            style="
                              color: #d82323;
                              font-family: nunitosansregular;
                              font-size: 12px;
                            "
                            >Female</span
                          >
                          <v-layout justify-start wrap>
                            <v-flex xs8>
                              <v-progress-linear
                                value="100"
                                color="#D82323"
                              ></v-progress-linear>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 pa-2>
                    <div class="dottedline"></div>
                  </v-flex>
                </v-layout>
                <table id="customers" class="hidden-sm-and-down">
                  <tr>
                    <td style="color: #8474f7; font-family: nunitosansregular">
                      PERCENTILE
                    </td>
                    <!-- <td style="color: #4d4d4d; font-family: nunitosanslight">
                      0
                    </td> -->
                    <td
                      v-for="(item, i) in percentileTable"
                      :key="i"
                      style="color: #4d4d4d; font-family: nunitosanslight"
                    >
                      {{ item.percentile }}
                    </td>
                  </tr>
                  <tr>
                    <td style="color: #8474f7; font-family: nunitosansregular">
                      CGPA
                    </td>
                    <td
                      v-for="(item, i) in percentileTable"
                      :key="i"
                      style="color: #000000; font-family: nunitosanssemibold"
                    >
                      {{ item.CGPA }}
                    </td>
                  </tr>
                </table>
                <v-layout justify-center wrap class="hidden-md-and-up">
                  <v-flex xs6 text-left>
                    <span
                      style="color: #8474f7; font-family: nunitosansregular"
                    >
                      PERCENTILE</span
                    >
                    <v-layout
                      justify-center
                      wrap
                      v-for="(item, i) in percentileTable"
                      :key="i"
                    >
                      <span
                        style="color: #4d4d4d; font-family: nunitosanslight"
                      >
                        {{ item.percentile }}</span
                      >
                    </v-layout>
                  </v-flex>
                  <v-flex xs6 text-center>
                    <span
                      style="color: #8474f7; font-family: nunitosansregular"
                    >
                      CGPA</span
                    >
                    <v-layout
                      justify-center
                      wrap
                      v-for="(item, i) in percentileTable"
                      :key="i"
                    >
                      <span
                        style="color: #000000; font-family: nunitosanssemibold"
                      >
                        {{ item.CGPA }}</span
                      >
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-card-text>
          <v-layout justify-center wrap pb-5 v-if="cls == 'School'">
            <v-flex xs12 sm6 md6 pa-4>
              <v-card outlined>
                <v-card-text>
                  <v-layout justify-start wrap pb-5>
                    <v-flex xs12>
                      <v-layout justify-start wrap>
                        <v-flex xs9>
                          <span
                            style="
                              color: #000000;
                              font-family: nunitosansbold;
                              font-size: 18px;
                            "
                            >Top 10 Percentile</span
                          >
                          <br />
                          <span
                            style="
                              color: #606060;
                              font-family: nunitosansregular;
                              font-size: 12px;
                            "
                            >Based on Gender</span
                          >
                          <br />
                          <span
                            style="
                              color: #000000;
                              font-family: nunitosanssemibold;
                              font-size: 14px;
                            "
                            >{{ top.totalCount }} Students</span
                          >
                        </v-flex>
                      </v-layout>
                      <v-layout justify-start wrap pt-5>
                        <v-flex xs12 sm6 md4 v-if="flag">
                          <div id="chart">
                            <apexchart
                              type="pie"
                              width="350"
                              :options="chartOptions1"
                              :series="series1"
                            ></apexchart>
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs12 sm6 md6 pa-4>
              <v-card outlined>
                <v-card-text>
                  <v-layout justify-start wrap pb-5>
                    <v-flex xs12>
                      <v-layout justify-start wrap>
                        <v-flex xs9>
                          <span
                            style="
                              color: #000000;
                              font-family: nunitosansbold;
                              font-size: 18px;
                            "
                            >Bottom 10 Percentile</span
                          >
                          <br />
                          <span
                            style="
                              color: #606060;
                              font-family: nunitosansregular;
                              font-size: 12px;
                            "
                            >Based on Gender</span
                          >
                          <br />
                          <span
                            style="
                              color: #000000;
                              font-family: nunitosanssemibold;
                              font-size: 14px;
                            "
                            >{{ bottom.totalCount }} Students</span
                          >
                        </v-flex>
                        <v-layout justify-end wrap>
                          <v-flex xs6 sm8 md10 text-right>
                            <span
                              style="
                                color: #606060;
                                font-family: nunitosansregular;
                                font-size: 12px;
                              "
                              >Download</span
                            >
                          </v-flex>
                          <v-flex xs1 text-right>
                            <v-icon
                              style="
                                color: #606060;
                                font-family: nunitosansregular;
                                font-size: 16px;
                              "
                              >mdi-download-outline</v-icon
                            >
                          </v-flex>
                        </v-layout>
                      </v-layout>
                      <v-layout justify-start wrap pt-5>
                        <v-flex xs12 sm6 md4 v-if="flag">
                          <div id="chart">
                            <apexchart
                              type="pie"
                              width="350"
                              :options="chartOptions2"
                              :series="series2"
                            ></apexchart></div
                        ></v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout justify-center wrap py-5 v-if="top.length > 0 && cls == 'Class'">
      <v-flex xs12>
        <v-card>
          <v-card-text>
            <v-layout justify-center wrap py-5>
              <v-flex xs11 sm12 md12>
                <v-card outlined>
                  <v-layout pa-5 justify-center wrap pb-5>
                    <v-flex xs12 v-for="(item, i) in top" :key="i">
                      <v-layout justify-center wrap>
                        <v-flex xs9>
                          <span
                            style="
                              color: #000000;
                              font-family: nunitosansbold;
                              font-size: 18px;
                            "
                            >{{ item.class.className }}</span
                          >
                        </v-flex>
                        <v-layout justify-end wrap>
                          <v-flex xs6 sm8 md5 text-right>
                            <span
                              style="
                                color: #606060;
                                font-family: nunitosansregular;
                                font-size: 12px;
                              "
                              >Download</span
                            >
                          </v-flex>
                          <v-flex xs1 text-right>
                            <v-icon
                              style="
                                color: #606060;
                                font-family: nunitosansregular;
                                font-size: 16px;
                              "
                              >mdi-download-outline</v-icon
                            >
                          </v-flex>
                        </v-layout>
                      </v-layout>
                      <v-layout justify-center wrap>
                        <v-flex xs12>
                          <span
                            style="
                              color: #606060;
                              font-family: nunitosansregular;
                              font-size: 12px;
                            "
                            >Top 5 Students</span
                          >
                        </v-flex>
                      </v-layout>
                      <v-layout justify-start wrap>
                        <v-flex
                          xs12
                          sm6
                          md4
                          v-for="list in item.data"
                          :key="list.index"
                        >
                          <v-layout justify-start wrap pt-3>
                            <v-flex xs3 pt-2>
                              <span
                                style="
                                  font-family: nunitosanssemibold;
                                  color: #9d9d9d;
                                "
                                >{{ list.student.admissionnumber }}</span
                              >
                            </v-flex>
                            <v-flex xs3 sm3 md3 lg2>
                              <v-avatar style="cursor: pointer" size="40">
                                <v-img
                                  :src="mediaURL + list.student.user.photo"
                                />
                              </v-avatar>
                            </v-flex>
                            <v-flex xs6 pt-2>
                              <router-link
                                :to="'/studentDetails/' + list.student._id"
                                style="text-decoration: none"
                              >
                                <span
                                  style="
                                    font-family: nunitosanssemibold;
                                    color: #000000;
                                  "
                                  >{{ list.student.user.name }}</span
                                ></router-link
                              >
                              <br />
                              <span
                                style="
                                  font-family: nunitosansbold;
                                  color: #000000;
                                "
                                >{{ list.CGPA.toFixed(2) }}</span
                              >
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                  <v-divider></v-divider>
                </v-card>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      hover: false,
      appLoading: false,
      ServerError: false,
      flag: false,
      cls: "",
      classid: "",
      standard: "",
      division: "",
      subject: "",
      classArray: [],
      standardArray: [],
      divisionArray: [],
      subArray: [],
      data: [],
      grpah: [],
      grpah2: [],
      school: [],
      cumilative: [],
      cumilative1: [],
      percentileTable: [],
      percentileTable1: [],
      top: [],
      bottom: [],
      items: ["School", "Class"],
      series1: [],
      chartOptions1: {
        chart: {
          width: 380,
          type: "pie",
        },
        labels: ["Girls", "Boys"],
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
        colors: ["#F76AA6", "#9B8DFD"],
      },
      series2: [35, 75],
      chartOptions2: {
        chart: {
          width: 380,
          type: "pie",
        },
        labels: ["Girls", "Boys"],
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
        colors: ["#F76AA6", "#9B8DFD"],
      },
      series: [
        {
          name: "Cumulative",
          data: [],
        },
        {
          name: "Male",
          data: [],
        },
        {
          name: "Female",
          data: [],
        },
      ],
      chartOptions: {
        chart: {
          height: 350,
          type: "line",
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "straight",
        },
        colors: ["#70CE11", "#8474F7", "#D82323"],
        // title: {
        //   text: 'Product Trends by Month',
        //   align: 'left'
        // },
        legend: {
          show: false,
          showForSingleSeries: false,
        },
        yaxis: {
          title: {
            text: "FREQUENCY OF STUDENTS",
            style: {
              fontSize: "14px",
              fontFamily: "nunitosansregular",
              colors: ["#8474F7"],
            },
          },
          labels: {
            style: {
              fontSize: "12px",
              fontFamily: "nunitosanssemibold",
              colors: ["#9A9A9A"],
            },
          },
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        xaxis: {
          categories: [],
          title: {
            text: "CGPA",
            style: {
              fontSize: "14px",
              fontFamily: "nunitosansregular",
              colors: ["#8474F7"],
            },
          },
          labels: {
            style: {
              fontSize: "12px",
              fontFamily: "nunitosanslight",
              colors: ["#4D4D4D"],
            },
          },
        },
      },
      series3: [
        {
          name: "Cumulative",
          data: [],
        },
        {
          name: "Male",
          data: [],
        },
        {
          name: "Female",
          data: [],
        },
      ],
      chartOptions3: {
        chart: {
          height: 350,
          type: "line",
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "straight",
        },
        colors: ["#70CE11", "#8474F7", "#D82323"],
        // title: {
        //   text: 'Product Trends by Month',
        //   align: 'left'
        // },
        legend: {
          show: false,
          showForSingleSeries: false,
        },
        yaxis: {
          title: {
            text: "FREQUENCY OF STUDENTS",
            style: {
              fontSize: "14px",
              fontFamily: "nunitosansregular",
              colors: ["#8474F7"],
            },
          },
          labels: {
            style: {
              fontSize: "12px",
              fontFamily: "nunitosanssemibold",
              colors: ["#9A9A9A"],
            },
          },
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        xaxis: {
          categories: [],
          title: {
            text: "CGPA",
            style: {
              fontSize: "14px",
              fontFamily: "nunitosansregular",
              colors: ["#8474F7"],
            },
          },
          labels: {
            style: {
              fontSize: "12px",
              fontFamily: "nunitosanslight",
              colors: ["#4D4D4D"],
            },
          },
        },
      },
    };
  },
  watch: {
    standard() {
      this.getSub();
      this.getCls();
    },
    division() {
      this.getCls();
    },
    cls() {
      if (this.cls == "School") {
        this.getGraph();
      }
    },
  },
  mounted() {
    this.cls = "School";
    this.getClass();
    this.getStandard();
    this.getDivision();
    this.getSub();
    this.getData();
    this.getCls();
    this.getGraph();
  },
  methods: {
    getCls() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/class/getclass",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          standard: this.standard,
          division: this.division,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.classArray = response.data.data;
          if (response.data.status) {
            this.classid = response.data.data._id;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    getGraph() {
      this.appLoading = true;
      this.flag = false;
      this.series3[0].data = [];
      this.series3[1].data = [];
      this.series3[2].data = [];
      this.series1 = [];
      // this.grpah2=[];
      axios({
        method: "GET",
        url: "/exam/mark/school/analytics",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.school = response.data.data;
          this.grpah2 = response.data.data.fullGraph;
          this.percentileTable = response.data.data.percentileTable;
          this.top = response.data.data.top10Percentile;
          this.cumilative = response.data.data.cumilative;
          this.bottom = response.data.data.bottom10Percentile;
          this.series1 = [this.top.femaleCount, this.top.maleCount];
          this.series2 = [this.bottom.femaleCount, this.bottom.maleCount];
          this.appLoading = false;
          for (var i = 0; i < this.grpah2.length; i++) {
            this.chartOptions3.xaxis.categories.push(
              parseFloat(this.grpah2[i].CGPA).toFixed(1)
            );
            this.series3[0].data.push(this.grpah2[i].cumilativeFequency);
            this.series3[1].data.push(this.grpah2[i].maleFequency);
            this.series3[2].data.push(this.grpah2[i].femaleFequency);
          }
          this.flag = true;
        })
        .catch((err) => {
          this.appLoading = false;
          // this.ServerError = true;
          console.log(err);
        });
    },
    getData() {
      this.appLoading = true;
      this.flag = false;
      this.series[0].data = [];
      this.series[1].data = [];
      this.series[2].data = [];
      this.top = [];
      axios({
        method: "GET",
        url: "exam/mark/analytics",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          classid: this.classid,
          standard: this.standard,
          subject: this.subject,
          division: this.division,
        },
      })
        .then((response) => {
          this.data = response.data.data;
          this.top = response.data.data.topFive;
          this.grpah = response.data.data.fullGraph;
          this.cumilative1 = response.data.data.cumilative;
          this.percentileTable1 = response.data.data.percentileTable;
          this.appLoading = false;
          for (var i = 0; i < this.grpah.length; i++) {
            this.chartOptions.xaxis.categories.push(
              parseFloat(this.grpah[i].CGPA).toFixed(1)
            );
            // this.chartOptions.yaxis.categories1.push(this.graph[i].frequency);
            this.series[0].data.push(this.grpah[i].cumilativeFequency);
            this.series[1].data.push(this.grpah[i].maleFequency);
            this.series[2].data.push(this.grpah[i].femaleFequency);
          }
          this.flag = true;
        })
        .catch((err) => {
          this.appLoading = false;
          // this.ServerError = true;
          console.log(err);
        });
    },
    getClass() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/class/getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          var temp = [
            {
              name: null,
              value: null,
            },
          ];
          temp = response.data.data;
          for (var i = 0; i < temp.length; i++) {
            temp[i].name = temp[i].className;
            temp[i].value = temp[i]._id;
          }
          this.classArray = temp;
          this.classArray.unshift({ name: "All", value: null });
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getStandard() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/standard/getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.standardArray = response.data.data;
          this.appLoading = false;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getDivision() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/division/getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.divisionArray = response.data.data;
          this.appLoading = false;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getSub() {
      this.appLoading = true;
      axios({
        url: "/standard/subject/getlist",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          standard: this.standard,
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.subArray = response.data.data;
            this.appLoading = false;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>
<style>
.dottedline {
  border: none;
  border-top: 2px dashed rgb(208, 208, 208);
  color: #8181812f;
  /* background-color:#8181812F; */
  height: 1px;
  width: 100%;
}
#customers td {
  padding: 8px;
}
#customers th {
  border-top: 2px;
}
#customers {
  border-collapse: collapse;
  width: 100%;
}
</style>